export function panelProps() {
    return {
        size: { type: [Number, String] },
        defaultSize: { type: [Number, String] },
        min: { type: [Number, String] },
        max: { type: [Number, String] },
        resizable: { type: Boolean, default: true },
        collapsible: {
            type: [Boolean, Object],
            default: false,
        },
        destroyOnHidden: { type: Boolean, default: undefined },
    };
}
export function splitterProps() {
    return {
        layout: { type: String, default: 'horizontal' },
        lazy: { type: Boolean, default: false },
        rootClassName: String,
    };
}
